import { Select } from 'ui/selectv2/Select';
import { colors, spacing } from 'ui/theme';
import styled from 'styled-components';
import { useIntegrationOptionsState } from './hooks/useIntegrationOptionsState';
import { useChildIntegrationOptionsState } from './hooks/useChildIntegrationOptionsState';
import { useTranslations } from '../../hooks/useTranslations';
import { Divider } from 'ui/divider';
import { useMovableInkIntegrationContext } from 'modules/movableInk/contexts/MovableInkIntegrationContext';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.plusHalf};
`;

const StyledDivider = styled(Divider)`
  margin: 0 -${spacing.layoutLRPadding} 0 -${spacing.layoutLRPadding};
  border-color: ${colors.borderPrimary};
`;

export const DATA_TEST = {
  integrationSelect: 'mi-panel-list-integration-select',
  childIntegrationSelect: 'mi-panel-list-child-integration-select',
};

export const IntegrationSelects = () => {
  const { t } = useTranslations();
  const { selectedOption, isDisabled, onSelect, options, isLoading } = useIntegrationOptionsState();
  const {
    selectedOption: selectedChildOption,
    isDisabled: isChildSelectDisabled,
    onSelect: onChildSelect,
    options: childOptions,
    isLoading: isChildSelectLoading,
    hasMultipleChildIntegrations,
  } = useChildIntegrationOptionsState();
  const { integrations } = useMovableInkIntegrationContext();

  return (
    <Wrapper>
      {integrations.length > 1 && (
        <Select
          id="tokenIdSelect"
          data-test={DATA_TEST.integrationSelect}
          onSelect={onSelect}
          options={options}
          value={selectedOption}
          isLoading={isLoading}
          isDisabled={isDisabled}
          placeholder={t('select.integration.placeholder')}
        />
      )}
      {hasMultipleChildIntegrations && (
        <Select
          id="companyIdSelect"
          data-test={DATA_TEST.childIntegrationSelect}
          onSelect={onChildSelect}
          options={childOptions}
          value={selectedChildOption}
          isLoading={isChildSelectLoading}
          isDisabled={isChildSelectDisabled}
          placeholder={t('select.childIntegration.placeholder')}
        />
      )}
      <StyledDivider />
    </Wrapper>
  );
};
